

//------------------------------------------------------------------------------
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
//------------------------------------------------------------------------------  

/**
  * 
  */
enum CircleMemberType {

  /**
   * Blacklisted, no booking allowed.
   */
  Blacklist = -1,

  /**
   * Whitelisted, can book any time.
   */
  Whitelist = 0,

  /**
   * Whitelisted and can manage CircleMembers and CircleMemberRequests.
   */
  WhitelistOwner = 1,

}

export default CircleMemberType;